import { render } from "./CollectionVideos.vue?vue&type=template&id=43875574&scoped=true"
import script from "./CollectionVideos.vue?vue&type=script&lang=js"
export * from "./CollectionVideos.vue?vue&type=script&lang=js"

import "./CollectionVideos.vue?vue&type=style&index=0&id=43875574&scoped=true&lang=css"
import "./CollectionVideos.vue?vue&type=style&index=1&id=43875574&lang=css"
import "./CollectionVideos.vue?vue&type=style&index=2&id=43875574&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43875574"]])

export default __exports__